import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import CookieConsent from '../../components/CookieConsent';
import LegalDocument from '../../components/LegalDocument';
import { legalDocuments } from '../../content/legalContent';

const LegalPage = ({ type }) => {
  const document = legalDocuments[type] || legalDocuments.terms;

  return (
    <>
      <Header />
      <main className="legal-page">
        <div className="container">
          <LegalDocument document={document} />
        </div>
      </main>
      <Footer />
      <CookieConsent />
    </>
  );
};

export default LegalPage;
